export default {"src":"/_next/static/media/bell-fill.4dc0916d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};